import React from 'react';
import { Row, Col } from 'react-bootstrap';
import FileGrid from './FileGrid';
import FileUploader from './FileUploader';
import { useLeadFiles } from '../hooks/useLeads';

function TabContent({ tabName, clientId, folder, availableSubFolders }) {
  const { data: files = [], isLoading, isError, error } = useLeadFiles(clientId, folder);

  // ── Sort files by date descending (newest first) ──────────────────────────
  const sortedFiles = [...files].sort(
    (a, b) => new Date(b.updateTime) - new Date(a.updateTime)
  );

  return (
    <>
      {/* ── Header row — always visible ─────────────────────────────────── */}
      <Row className="align-items-center mb-3">
        <Col>
          <h5 style={{ margin: 0, color: '#154889', fontWeight: 700 }}>
            {tabName}
          </h5>
          {/* File count badge — shows 0 when empty, not hidden */}
          <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
            {isLoading ? 'Loading…' : `${sortedFiles.length} file${sortedFiles.length !== 1 ? 's' : ''}`}
          </span>
        </Col>
        <Col className="text-end">
          {/* Upload button always visible so user can add files even when empty */}
          <FileUploader
            clientId={clientId}
            folder={folder}
            availableSubFolders={availableSubFolders}
          />
        </Col>
      </Row>

      {/* ── File list ────────────────────────────────────────────────────── */}
      <div>
        {isLoading ? (
          <div style={{ textAlign: 'center', padding: '40px 0', color: '#94a3b8' }}>
            Loading files…
          </div>
        ) : isError ? (
          <div style={{ color: '#ef4444', padding: '12px' }}>
            Error: {error.message}
          </div>
        ) : sortedFiles.length > 0 ? (
          // Pass pre-sorted files — FileGrid just renders what it receives
          <FileGrid files={sortedFiles} clientId={clientId} folder={folder} />
        ) : (
          // Empty state — folder UI is still fully visible, just no files yet
          <div style={{
            textAlign: 'center', padding: '60px 0',
            color: '#94a3b8', border: '2px dashed #e5e7eb',
            borderRadius: '12px', marginTop: '12px',
          }}>
            <FolderEmptyIcon />
            <p style={{ marginTop: '12px', fontWeight: 500 }}>No files in this folder yet</p>
            <p style={{ fontSize: '0.8rem' }}>Use the upload button above to add files</p>
          </div>
        )}
      </div>
    </>
  );
}

// Simple inline SVG so no extra dependency needed
function FolderEmptyIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
      stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </svg>
  );
}

export default TabContent;